export function nextFocusIndex(current:number,total:number,reverse=false):number{
  if(total<=0)return -1;
  return (current+(reverse?-1:1)+total)%total;
}
